import React from 'react';
import { connect } from 'react-redux';

import LocationCard from '../../../cards/LocationCard';
import Info from './Info';
import PaidHitAvailability from '../../../Profile/AboutContent/PaidHitAvailability';
import { getClubNameDisplay, ClubTierTypes } from '../../../../utils/clubs';

const SidePanelBottomSection = (props) => {
    const {
        clubDetails,
    } = props;

    const {
        location,
        tierType,
        schoolProfile,
        name,
        url,
    } = clubDetails;

    const displayName = getClubNameDisplay(tierType, schoolProfile, name);
    const isPaidHitClub = tierType?.id === ClubTierTypes.PAID_HIT;

    return (
        <React.Fragment>
            {isPaidHitClub && (
                <PaidHitAvailability
                    paidHitAvailability={props.profile?.data?.paidHitAvailability}
                />
            )}
            <LocationCard
                title={'Location'}
                name={displayName}
                location={location}
            />
            <Info
                url={url}
                tierType={tierType}
            />
        </React.Fragment>
    );
};

function mapStateToProps({ profile }) {
    return { profile };
}

export default connect(mapStateToProps)(SidePanelBottomSection);
